export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-11.59e6e7ba.jpg";